import { create } from 'zustand';

import {
  createGroupCompositeThumbnailSlice,
  type GroupCompositeThumbnailSlice,
} from './slices/createGroupCompositeThumbnailSlice';

export type GroupCompositeThumbnailState = GroupCompositeThumbnailSlice;

export const useGroupCompositeThumbnailStore = create<GroupCompositeThumbnailState>()((...args) => ({
  ...createGroupCompositeThumbnailSlice()(...args),
}));
